import { gql } from "@apollo/client";

export const getLensDestinations = gql`
    query getLensDestinations($lensId: ID!, $lensFolderId: ID!) {
        getLensDestinations(input: { lensId: $lensId, lensFolderId: $lensFolderId }) {
            destinations {
                id
                destinationType
                status
                lensId
                publicProfileMetadata {
                    id
                    description
                    displayName
                    organizationId
                    snapUserName
                }
            }
        }
    }
`;
